window.addEventListener("load",function(){
  $(document).ready(function() {
    $('#submitOTPButton').prop('disabled', true);
    $('input#otpInput').keyup(function() {
        if($(this).val() != '') {
            $('#submitOTPButton').prop('disabled', false);
        }
     });
 });
});
$(document).ready(function() {
    $('#getOTPButton').prop('disabled', true);
    $('#smlPhoneNumberInput').keyup(function() {
        if($(this).val() != '') {
            $('#getOTPButton').prop('disabled', false);
        }
     });
 });jQuery(document).ready(function(){
	jQuery(".home-slider").slick({
		dots: false,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		settings: {
			autoplay:true,
			autoplaySpeed:2000,
		},
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					autoplay:true,
					autoplaySpeed:2000,
				}
			}
		]
	});
	jQuery(".new-slider").slick({
		dots: true,
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1499,
				settings: {
				  slidesToShow: 4,
				}
			},
			{
				breakpoint: 1199,
				settings: {
				  slidesToShow: 3,
				}
			},
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
				breakpoint: 767,
				settings: {
				  slidesToShow: 1,
				}
			}
		]
	});
	
	jQuery(".seller-slider").slick({
		dots: false,
		arrows: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1499,
				settings: {
				  slidesToShow: 1,
				}
			},
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 1,
			  }
			},
			{
				breakpoint: 767,
				settings: {
				  slidesToShow: 1,
				}
			}
		]
	});
	jQuery(".watch-slider").slick({
		dots: true,
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1399,
				settings: {
				  slidesToShow: 3,
				}
			},
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
				breakpoint: 767,
				settings: {
				  slidesToShow: 2,
				}
			}
		]
	});
	jQuery(".follow-slider").slick({
		dots: false,
		arrows: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1399,
				settings: {
				  slidesToShow: 3,
				}
			},
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 3 ,
			  }
			},
			{
				breakpoint: 767,
				settings: {
				  dots: true,
				  slidesToShow: 3,
				}
			}
		]
	});
	jQuery(".blog-slider").slick({
		dots: true,
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1399,
				settings: {
				  slidesToShow: 3,
				}
			},
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
				breakpoint: 767,
				settings: {
				  slidesToShow: 1,
				}
			}
		]
	});
	var $mainSlider = $('.pdp-slider');
    var $navSlider = $('.pdp-nav-slider');

    // Main PDP Slider Init
    $mainSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        asNavFor: '.pdp-nav-slider',
    });

    // Thumbnail Nav Slider Init
    $navSlider.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: false,
        asNavFor: '.pdp-slider',
        dots: false,
        arrows: true,
        infinite: false,
        vertical: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    arrows: true,
                    vertical: false,
                    dots: false,
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 479,
                settings: {
                    arrows: true,
                    vertical: false,
                    dots: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // Active Class Handler Function
    function setNavActiveClass(activeIndex) {
        // Thumbnail slider ki sabhi slides se pehle class remove karo
        $navSlider.find('.slick-slide').removeClass('active-nav-thumb');
        
        // Exact same index wali thumbnail slide par class add karo
        $navSlider.find('.slick-slide[data-slick-index="' + activeIndex + '"]').addClass('active-nav-thumb');
    }

    // 1. Page Load hone par initial active slide par class add karein
    setNavActiveClass(0);

    // 2. Main Slider jab bhi change ho (swipe/arrow), Nav Thumbnail update karein
    $mainSlider.on('afterChange', function (event, slick, currentSlide) {
        setNavActiveClass(currentSlide);
    });
	
  jQuery('.blog-top-slider').slick({
		dots: false,
		arrows: true,
		slidesToShow: 7,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1499,
				settings: {
					arrows: true,
					dots: false,
					slidesToShow: 6,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1299,
				settings: {
					arrows: true,
					dots: false,
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 440,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery(".explore-recipe-slider").slick({
		dots: false,
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
				breakpoint: 767,
				settings: {
				  slidesToShow: 1,
				}
			}
		]
	});
	jQuery(".recipe-left .recipe-left-top .fiter-title").click(function(){
		jQuery(".recipe-main .recipe-left").toggleClass('active');
	});

setTimeout(function () {
  let currItem = $('.blog-top-slider.slick-initialized').find('.slick-slide:not(.slick-cloned) > a.active').parent().attr('data-slick-index');
  $('.blog-top-slider').slick('slickGoTo', currItem);
}, 600);

  
	// $('.add').click(function () {
	// 	var th = $(this).closest('.wrap').find('.count');
    //     var qty = (th.val()*1) + 1
	// 	th.val(qty);
    //     $('#pdpQty').val(qty)
	// });
	// $('.sub').click(function () {
	// 	var th = $(this).closest('.wrap').find('.count');
	// 	if (th.val() > 1){
    //     var qty = (th.val()*1) - 1
    //       th.val(qty);
    //       $('#pdpQty').val(qty)
    //     } 
	// });



$('.add').click(function () {

    var th = $(this).closest('.wrap').find('.count');
    var qty = (parseInt(th.val()) || 1) + 1;

    th.val(qty).trigger('change');

});

$('.sub').click(function () {

    var th = $(this).closest('.wrap').find('.count');

    if ((parseInt(th.val()) || 1) > 1) {

        var qty = (parseInt(th.val()) || 1) - 1;

        th.val(qty).trigger('change');
    }

});


	setTimeout(function() {
		jQuery('.news-tab li a, .blog-top-slider li a').on('click', function(){
			var target = jQuery(this).attr('data-rel');
		 jQuery('.news-tab li a, .blog-top-slider li a').removeClass('active');
			jQuery(this).addClass('active');
			jQuery("#"+target).fadeIn('slow').siblings(".blog-tab-box").hide();
		});
	}, 1000);
	jQuery('.technical-tab li a').on('click', function(){
		var target = jQuery(this).attr('data-rel');
	 jQuery('.technical-tab li a').removeClass('active');
		jQuery(this).addClass('active');
		jQuery("#"+target).fadeIn('slow').siblings(".technical-main").hide();
		return false;
	});
	jQuery(".share-btn").click(function(){
		jQuery(this).parent(".pdp-slider-card").toggleClass('active').siblings().removeClass('active');
	});
//   jQuery('.technical-tab li a').on('click', function(){
// 		var target = jQuery(this).attr('data-rel');
// 	 jQuery('.technical-tab li a').removeClass('active');
// 		jQuery(this).addClass('active');
// 		jQuery("#"+target).fadeIn('slow').siblings(".technical-main").hide();
// 		return false;
// 	});
	jQuery(".share-btn").click(function(){
		jQuery(this).parent(".pdp-slider-card").toggleClass('active').siblings().removeClass('active');
	});
	setTimeout(function() {
		jQuery('.news-tab li a, .blog-top-slider li a').on('click', function(){
			var target = jQuery(this).attr('data-rel');
		 jQuery('.news-tab li a, .blog-top-slider li a').removeClass('active');
			jQuery(this).addClass('active');
			jQuery("#"+target).fadeIn('slow').siblings(".blog-tab-box").hide();
		});
	}, 1000);
	var counted = 0;
	$(window).on('scroll',function () {
		var divv = $('#counter');
		if (divv.length) {
			var oTop = $('#counter').offset().top - window.innerHeight;
			if (counted == 0 && $(window).scrollTop() > oTop) {
				$('.count').each(function () {
					var $this = $(this),
						countTo = $this.attr('data-count');
					$({
						countNum: $this.text()
					}).animate({
						countNum: countTo
					},
						{
							duration: 2000,
							easing: 'swing',
							step: function () {
								$this.text(Math.floor(this.countNum));
							},
							complete: function () {
								$this.text(this.countNum);
								//alert('finished');
							}
						});
				});
				counted = 1;
			}
		}
	
	 
	
	});
	jQuery('.scroll-down-arrow').click(function() {
		jQuery('html, body').animate({
		  scrollTop: $(".why-kenstar").offset().top
		}, 1000)
	});

  
	jQuery(".faq-card-top").click(function() {
		if (jQuery(this).hasClass('active')) {
		  jQuery(this).removeClass('active');
		  jQuery(this).siblings('.faq-content-card').slideUp();
		}
		else {
		  jQuery(".faq-card-top").removeClass('active');
		  jQuery('.faq-content-card').slideUp();
		  jQuery(this).addClass('active');
		  jQuery(this).siblings('.faq-content-card').slideDown();
		}
	});
  
	if(window.matchMedia("(max-width: 1299px)").matches){
		jQuery('.nav-item .arrow').click( function(){
			jQuery(this).parent(".nav-item").toggleClass('active').siblings().removeClass('active');
		});
		jQuery('.grandchild-menu .arrow').click( function(){
			jQuery(this).parent(".grandchild-menu").toggleClass('active').siblings().removeClass('active');
		});
      jQuery(".sidebar-togle-wraper").click(function(){
			  jQuery(".layer-bg").addClass("active");
			  jQuery(".header-bottom").addClass("active");
			  jQuery('html').addClass('overflow-hiiden');
    		});
		jQuery(".layer-bg").click(function(){
			  jQuery(this).removeClass("active");
			  jQuery(".header-bottom").removeClass("active");
			  jQuery('html').removeClass('overflow-hiiden');
		});
		jQuery(".cross-icon").click(function(){
			  jQuery(".layer-bg").removeClass("active");
			  jQuery(".header-bottom").removeClass("active");
			  jQuery('html').removeClass('overflow-hiiden');
		});
		jQuery(".search-icon").click(function(){
			jQuery(".header-search").addClass("active");
	  	});
		jQuery(".search-box .close").click(function(){
			jQuery(".header-search").removeClass("active");
	  	});
      jQuery(".account-left-top").click(function(){
			jQuery(".account-left").toggleClass("accountactive");
	  	});
	}

	if(window.matchMedia("(max-width: 767px)").matches){
		jQuery(".discover-slider").slick({
			dots: false,
			arrows: true,
			centerMode: true,
			slidesToShow: 1,
			slidesToScroll: 1,
		});
		jQuery(".kenstarxxsheading").click(function() {
			if (jQuery(this).hasClass('in')) {
			  jQuery(this).removeClass('in');
			  jQuery(this).siblings('.ftr-content').slideUp();
			}
			else {
			  jQuery(".kenstarxxsheading").removeClass('in');
			  jQuery('.ftr-content').slideUp();
			  jQuery(this).addClass('in');
			  jQuery(this).siblings('.ftr-content').slideDown();
			}
		});
		// jQuery('.plp-top-slider').slick({
		// 	slidesToShow: 3,
		// 	slidesToScroll: 1,
		// 	arrows: false,
		// 	infinite: false,
		// });
        jQuery('.recent-slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
		});
	}
});
var $status = $('.slider-count');
var $slickElement = $('.home-slider');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text('0'+i +' / '+slick.slideCount);
});
window.addEventListener("load",function(){
  $(document).ready(function() {
      $('#getOTPButton').prop('disabled', true);
      $('#smlPhoneNumberInput').keyup(function() {
          if($(this).val() != '') {
              $('#getOTPButton').prop('disabled', false);
          }
       });
  });
  
  $(function(){
    var regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,10}$/;
  
    $('#RegisterForm-password[type="password"]').on('keyup', function() {
      $('.message').hide();
      if( regExp.test( $(this).val() )){
         $('.message.success').show();
        $('#valPass').prop('disabled', false);
}
 else{
         $('.message.error').show();
        $('#valPass').prop('disabled', true);
}
       
  
    });
  
  });
});

document.addEventListener('DOMContentLoaded', function () {
	const filterTabs = document.querySelectorAll('.filter-col');
		filterTabs.forEach(tab => {
			const filterHeader = tab.querySelector('.filter-col-title');

			filterHeader.addEventListener('click', () => {
			filterTabs.forEach(item => {
				if (item !== tab) item.classList.remove('active');
			});

			tab.classList.toggle('active');
			});
	});
});

// add to cart mobile sticky

document.addEventListener("DOMContentLoaded", function () {

  const stickyCart = document.querySelector(".sticky-add-to-cart");
  const stickyPriceBar = document.querySelector("#sticky-price-bar");

  // Sirf ORIGINAL Add to Bag select karo
  // Sticky Add to Cart ke andar wala .add-bag ignore hoga
  const originalAddBag = [...document.querySelectorAll(".add-bag")]
    .find(el => !el.closest(".sticky-add-to-cart"));

  if (!originalAddBag) return;

  function updateSticky() {
    const rect = originalAddBag.getBoundingClientRect();

    // Original Add to Bag viewport ke upar chala gaya
    const showSticky = rect.bottom <= 0;

    if (stickyCart) {
      stickyCart.classList.toggle("is-visible", showSticky);
    }

    if (stickyPriceBar) {
      stickyPriceBar.classList.toggle("show", showSticky);
    }
  }

  window.addEventListener("scroll", updateSticky, {
    passive: true
  });

  window.addEventListener("resize", updateSticky);

  // Page load par bhi check
  updateSticky();

});
